import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-rigth',
  templateUrl: './section-rigth.component.html',
  styleUrls: ['./section-rigth.component.scss']
})
export class SectionRigthComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
